import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { t } from '@/i18n'

Vue.config.productionTip = false
Vue.prototype.$t = t

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
